import store from '@app/store';
import emitter from 'tiny-emitter/instance';
import { GalleryItem } from '@app/models';

let shouldReconnect = false;
let reconnectDelay = 1000;
const MAX_RECONNECT_DELAY = 30000;

const handleWebSocketMessage = (event: MessageEvent) => {
  const message = JSON.parse(event.data);
  if (message.type === 'ping') {
    const socket = event.target as WebSocket;
    socket.send(JSON.stringify({ type: 'pong' }));
    return;
  }
  if (message.type === 'entity_type_update') {
    store.commit('updateEntityType', message.data);
  }
  if (message.type === 'text_field_update') {
    emitter.emit('textFieldUpdated', message.data);
  }
  if (message.type === 'entity_gallery_item_created') {
    emitter.emit('entityGalleryItemCreated', new GalleryItem(message.data));
  }
  if (message.type === 'universe_gallery_item_created') {
    emitter.emit('universeGalleryItemCreated', new GalleryItem(message.data));
  }
};

export const subscribeToUniverse = (websocket: WebSocket, universeId: string) => {
  if (websocket.readyState === WebSocket.OPEN) {
    websocket.send(JSON.stringify({
      type: 'subscribe',
      universe_id: universeId,
    }));
  }
};

const connect = (): WebSocket => {
  let url = COW_API_URL;
  url = url.replace('https', 'wss');
  url = url.replace('http', 'ws');
  const socket = new WebSocket(`${url}/websocket`);

  socket.addEventListener('message', handleWebSocketMessage);

  socket.addEventListener('open', () => {
    reconnectDelay = 1000;
    const { universes } = store.state;
    if (universes) {
      for (const universe of universes) {
        subscribeToUniverse(socket, universe.id);
      }
    }
  });

  socket.addEventListener('close', () => {
    if (shouldReconnect) {
      setTimeout(() => {
        if (shouldReconnect) {
          store.commit('setWebSocket', connect());
        }
      }, reconnectDelay);
      reconnectDelay = Math.min(reconnectDelay * 2, MAX_RECONNECT_DELAY);
    }
  });

  return socket;
};

export const openWebSocket = (): WebSocket => {
  shouldReconnect = true;
  reconnectDelay = 1000;
  return connect();
};

export const closeWebSocket = (websocket: WebSocket) => {
  shouldReconnect = false;
  websocket.close();
};
